import {lazy} from "react";

export const PointTemplatesSingleVoyageLazy = lazy(() => import('./PointTemplatesSingleVoyage'))
